import { Spin } from 'antd'
import { calc } from 'antd/es/theme/internal'
import React from 'react'

const FullPageLoader = () => {
  return (
    <div
      className="d-flex align-items-center justify-content-center w-100"
      style={{ height: '100%' }}
    >
      <div className="container">
        <div className="row">
          <div className="col text-center">
            <Spin />
          </div>
        </div>
      </div>
    </div>
  )
}

export default FullPageLoader
